export default {
    'buttonLabelExport': 'Export2',
};
